import React, { useEffect } from 'react';
import BaksoTigerGame from './BaksoGame';
import styles from './Games.module.css';

const BaksoMainGame = () => {
  // This effect ensures content is positioned below the navbar
  useEffect(() => {
    // Function to adjust the game container position
    const adjustGamePosition = () => {
      // Find the navbar element - try multiple possible selectors
      const navElement = document.querySelector('nav, header, .header, .navbar');
      
      if (navElement) {
        const navHeight = navElement.getBoundingClientRect().height;
        
        // Get the game container and adjust its positioning
        const gamePageElement = document.querySelector(`.${styles.gamesPage}`);
        if (gamePageElement) {
          (gamePageElement as HTMLElement).style.marginTop = `${navHeight}px`;
          (gamePageElement as HTMLElement).style.height = `calc(100vh - ${navHeight}px)`;
        }
      }
    };
    
    // Run on mount with a small delay to ensure DOM is ready
    setTimeout(adjustGamePosition, 100);
    
    // Also run when window is resized
    window.addEventListener('resize', adjustGamePosition);
    
    // Cleanup
    return () => window.removeEventListener('resize', adjustGamePosition);
  }, [styles.gamesPage]);
  
  return (
    <div className={styles.gamesPage}>
      <BaksoTigerGame />
    </div>
  );
};

export default BaksoMainGame;